export class InvalidUserSessionError extends Error {
  constructor() {
    super('Uporabniška seja ni več veljavna.');
    this.name = 'InvalidUserSessionError';
  }
}

export class PinRateLimitError extends Error {
  constructor() {
    super('Preveč neuspelih poskusov. Počakajte 15 minut in poskusite znova.');
    this.name = 'PinRateLimitError';
  }
}
